import { httpBus } from "@/api/index.js";
import dayjs from 'dayjs'

/**
 * 获取行政区域信息
 * 省-市
 * @returns 
 */
export function queryAdRegionInfo() {
  return httpBus.request("get", "/schedule/job/weather/district/queryProvinceCity");
}


/**
 * 获取一个地区的电价信息
 * @param {*} adCode 行政编码
 * @param {*} month 月份[可选参数]
 * @param {number} [priceType] 业务类型：1 代理购电；2 充电桩（现货不传 priceType）
 * @returns 列表项含 industry / industryType：0 一般工商业，1 大工业；type / systemType：0 单一制，1 两部制
 */
export function queryElecPriceInfoForAd({ adCode, month, priceType }) {
  const params = {
    areaCode: adCode,
  }
  if (month) {
    params['monthValue'] = month;
  }
  if (priceType !== undefined && priceType !== null && priceType !== '') {
    params.priceType = priceType
  }
  return httpBus.request("get", "/dashboard/state/grid/price/query", {
    params,
  });
}


/**
 * 获取默认配置信息：根据行政区域编码
 * @param {*} adCode 
 * @returns 
 */
export function queryDefaultAnalyseOptions(adCode, type = 0, priceType) {
  const params = {
    areaCode: adCode,
  }
  // 后端约定：type 默认一直传 0
  params.type = type
  // 业务类型：1 代理购电；2 充电桩（用于区分不同入口的配置回显；现货不传 priceType）
  if (priceType !== undefined && priceType !== null && priceType !== '') {
    params.priceType = priceType
  }
  return httpBus.request("get", "/dashboard/state/grid/price/recognize/query", {
    params,
  });
};

/**
 * 获取省份对应的时段标准（尖/峰/平/谷/深谷起止时间）
 * @param {string|number} year YYYY
 * @param {string|number} provinceCode 省级行政编码
 */
export function queryProvinceSegmentsInfo(year, provinceCode) {
  const params = {
    year: dayjs(year).format('YYYY'),
    provinceCode,
  }
  return httpBus.request("get", "/command/meterRatePeriod/getStandard", {
    params,
  })
}


/**
 * 提交：识别图片中信息时需要的配置项
 * @param {*} params 
 * @returns 
 */
export function commitAnalyseOptions(params) {
  return httpBus.request("post", "/dashboard/state/grid/price/recognize/save", {
    data: params,
  });
}


/**
 * 提交：要识别的图片
 * @param {*} params 
 * @returns 
 */
export function commitElecPriceImg(params) {
  return httpBus.request("post", "/schedule/job/state/grid/price/image/recognize", {
    data: params,
  },
  {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}


/**
 * 提交：编辑内容（batchSave）
 * @param {Array<{
 *   id?: *,
 *   areaName?: string,
 *   areaCode?: string,
 *   industry?: 0|1,
 *   type?: 0|1,
 *   priceType?: number,
 *   voltageLevel?: string,
 *   monthValue?: string,
 *   …价格字段
 * }>} params 行数据；industry 仅 0/1（0 一般工商业，1 大工业），type 为单一制/两部制
 * @returns
 */
export function commitEditData(params) {
  return httpBus.request("post", "/dashboard/state/grid/price/batchSave", {
    data: params,
  });
}


/**
 * 获取各省电价历史的列表
 * @param {*} areaCode 行政代码
 * @param {*} monthValue 月份
 * @param {*} industry 工业类型: 0 一般工商业；1 大工业
 * @param {*} type 用电方式: 0 单一制；1 两部制
 * @param {*} voltageLevel 电压等级: 1kv，10kv，20kv，35kv，110kv, 220kv
 * @param {*} pageSize 
 * @param {*} pageNum 
 * @returns 
 */
export function queryHistoryList(params) {
  return httpBus.request("get", "/dashboard/state/grid/price/list", {
    params,
  });
};







